import { createSvgIcon } from '@mui/material';
// or with custom SVG
export const CheckBoxIcon = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    strokeWidth={1}
    stroke="currentColor"
  >
    <g filter="url(#filter0_d_6658_31220)">
      <rect
        x="2.5"
        y="2.5"
        width="15"
        height="15"
        rx="4"
        strokeWidth={0}
        stroke="currentColor"
      />
    </g>
    <path
      d="M6.45837 9.99993L8.81671 12.3583L13.5417 7.6416"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
  "CheckBox",
);
